<template>
  <div class="terminal-border">
    <div class="actions">
      <font-awesome-icon :icon="['fas', 'circle']" class="icon exit" />
      <font-awesome-icon :icon="['fas', 'circle']" class="icon minimize" />
      <font-awesome-icon :icon="['fas', 'circle']" class="icon maximize" />
    </div>

    <div class="title text-terminal text-black">
      <font-awesome-icon :icon="['fas', 'folder-open']" class="icon" />
      {{ this.title }}
    </div>

    <div class="actions hide">
      <font-awesome-icon :icon="['fas', 'circle']" class="icon exit" />
      <font-awesome-icon :icon="['fas', 'circle']" class="icon minimize" />
      <font-awesome-icon :icon="['fas', 'circle']" class="icon maximize" />
    </div>
  </div>
</template>

<script>
export default {
  name: "window-top-border",
  props: {
    title: {
      type: String,
      default: "Unnamed",
      required: false
    }
  }
};
</script>

<style scoped>
.terminal-border {
  width: 100%;
  display: flex;
  flex-direction: row;
  height: 30px;
  background-color: #f1f1f1;
  align-items: center;
  justify-content: space-between;
}
.actions {
  padding-left: 10px;
}

.icon {
  color: #585858;
  font-size: 17px;
  padding: 0px 6px 0px 0px;
}
.icon.exit {
  color: #ee5e58;
}
.icon.maximize {
  color: #58ee65;
}
.icon.minimize {
  color: #eec958;
}

.title {
  font-size: 16px;
}
.title > .icon {
  color: rgb(124, 124, 124);
  padding-right: 0px;
}
.hide {
  opacity: 0 !important;
}
</style>
